// extracted by mini-css-extract-plugin
export default {"lineButtons":"realEstateItem_lineButtons__jbRkg","headers":"realEstateItem_headers__xgqWQ","twoInLine":"realEstateItem_twoInLine__K1PVT"};